import React, { useEffect } from 'react';

interface MobileMenuProps {
  isOpen: boolean;
  onClose: () => void;
  navLinks: Array<{ id: string; label: string }>;
  onNavigate: (id: string) => void;
}

export const MobileMenu: React.FC<MobileMenuProps> = ({ isOpen, onClose, navLinks, onNavigate }) => {
  // Handle ESC key to close menu
  useEffect(() => {
    const handleEsc = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener('keydown', handleEsc);
      document.body.style.overflow = 'hidden';
    }

    return () => {
      document.removeEventListener('keydown', handleEsc);
      document.body.style.overflow = 'unset';
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <>
      {/* Backdrop */}
      <div
        className="fixed inset-0 bg-black/70 backdrop-blur-sm z-40 md:hidden transition-opacity"
        onClick={onClose}
      />

      {/* Menu Panel */}
      <div className="fixed top-20 left-0 right-0 bottom-0 bg-dark-lighter z-50 md:hidden overflow-y-auto">
        <div className="flex flex-col items-center justify-center min-h-full py-8 px-4">
          {navLinks.map((link) => (
            <button
              key={link.id}
              onClick={() => onNavigate(link.id)}
              className="text-2xl text-gray-300 hover:text-primary transition-colors duration-300 py-4 w-full text-center font-medium"
            >
              {link.label}
            </button>
          ))}
        </div>
      </div>
    </>
  );
};
